import React, { useEffect, useState } from 'react'
import { Player as VideoPlayer, ControlBar, LoadingSpinner } from 'video-react'

import './index.scss'

interface PlayerProps extends React.MediaHTMLAttributes<any> {
  source: string
  seekTime?: number
}

let vplayer: any

const Player: React.FC<PlayerProps> = props => {
  const { source, seekTime = 0 } = props
  const [currentTime, setCurrentTime] = useState(0)
  const [prevSeekTime, setPrevSeekTime] = useState(seekTime)

  useEffect(() => {
    vplayer.play()
    vplayer.subscribeToStateChange((state: any) => {
      setCurrentTime(state.currentTime)
      if (state.ended) {
        vplayer.play()
      }
    })
  }, [])

  useEffect(() => {
    if (!source) {
      vplayer.load()
      return
    }
    vplayer.play()
  }, [source])

  useEffect(() => {
    if (seekTime === prevSeekTime) return
    setPrevSeekTime(seekTime)

    const isSeek = Math.abs(seekTime - currentTime) >= 1
    if (isSeek) {
      vplayer.seek(seekTime)
    }
  }, [seekTime, prevSeekTime, currentTime])

  return (
    // TODO: 这里使用的 video-react 包，无法解决安卓浏览器禁止视频自动全屏
    // 所以手动修改了 video-react/lib/components/Video.js 文件 641 行
    // 增加了以下两个属性：
    // "x5-playsinline": "true",
    // "webkit-playsinline": "true",
    <VideoPlayer
      playsInline
      fluid={false}
      width="100%"
      height={200}
      src={source}
      ref={(player: any) => {
        vplayer = player
      }}
    >
      <ControlBar disableCompletely />
      <LoadingSpinner />
    </VideoPlayer>
  )
}

export default Player
